module.exports = __webpack_public_path__ + "img/panorama.b026c6ad.png";